export default class Cookies {
  constructor() {
    this.cookieBanner = document.querySelector("cookie-banner")
    this.manageCookiesButton = document.getElementById("manage-cookies")
    this.init()
  }

  init() {
    if (this.manageCookiesButton) {
      this.manageCookiesButton.addEventListener("click", () => {
        if (this.cookieBanner) {
          this.cookieBanner.promptForConsent()
        }
      })
    }
  }
}
